import useAllLeasingCombinations from './react-query/use-all-leasing-combinations';

export const useUserCompaniesReferenceValues = () => {
  const { allLeasingCombinations } = useAllLeasingCombinations();

  const referenceCombination = allLeasingCombinations?.find(combination => combination.is_reference_combination);
  const referenceDistance = referenceCombination?.uds_distancevalue?.value || null;
  const referenceDuration = referenceCombination?.uds_monthvalue?.value || null;

  return {
    referenceDistance: allLeasingCombinations ? referenceDistance : undefined,
    referenceDuration: allLeasingCombinations ? referenceDuration : undefined
  };
};
